module.exports = {"No Data":"Brak danych","Total":"Wszystkich","items / page":"ilość / strona"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/lang/DataTableComponent/pl.json
// module id = 1482
// module chunks = 2